/**
 * @file
 * Local tasks functionality.
 */

((Drupal, once) => {

  /**
   * Toggle local tasks.
   *
   * @param props
   */
  function toggleLocalTasks(props) {
    props._$items.classList.toggle('show');
  }

  /**
   * Initialize local tasks.
   *
   * @param props
   */
  function init(props) {
    props._$trigger.addEventListener('click', () => {
      toggleLocalTasks(props);
    });
  }

  Drupal.behaviors.localTasks = {
    attach(context) {
      const _$trigger = once('trigger', '[data-local-tasks]', context).shift();
      const _$items = once('items', '[data-local-tasks-items]', context).shift();

      // If there is a trigger.
      if (_$trigger) {
        init({_$trigger, _$items});
      }
    }
  };
})(Drupal, once);
